export default __webpack_public_path__ + "static/media/7 a.f6bda7bc.png";